var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 2.4C4.90721 2.4 2.4 4.90721 2.4 8C2.4 11.0928 4.90721 13.6 8 13.6C11.0928 13.6 13.6 11.0928 13.6 8C13.6 4.90721 11.0928 2.4 8 2.4ZM1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8Z",
    fill: "#9C84FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.48544 11V6.63636H8.51385V11H7.48544ZM8.00249 6.01705C7.83961 6.01705 7.69946 5.96307 7.58203 5.85511C7.46461 5.74526 7.40589 5.61364 7.40589 5.46023C7.40589 5.30492 7.46461 5.1733 7.58203 5.06534C7.69946 4.95549 7.83961 4.90057 8.00249 4.90057C8.16726 4.90057 8.30741 4.95549 8.42294 5.06534C8.54036 5.1733 8.59908 5.30492 8.59908 5.46023C8.59908 5.61364 8.54036 5.74526 8.42294 5.85511C8.30741 5.96307 8.16726 6.01705 8.00249 6.01705Z",
    fill: "#9C84FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.f2e9402e8b374d315589c1f327753a36.svg";
export { ForwardRef as ReactComponent };